// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

/**
 * It's a necessary style that we need for all projects
 */
export const xSwiperStyle = css`
    width: 100%;
    .swiper-slide {
        // to make all slides has the same height
        height: auto;
        // To fix swiper render issue
        margin-top: 1px;
        margin-bottom: 1px;
        position: relative;
    }

    // hide swiper arrow navigation and use custom arrow navigation
    .swiper-button-prev,
    .swiper-button-next {
        display: none;
    }

    // override .swiper-pagination-bullets styles
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: initial;
        top: initial;
        left: initial;
        width: initial;
    }
`;

export const xSwiperStickyDots = css`
    &&& .xng-pagination-container {
        box-sizing: content-box;
        z-index: 10;
        left: 50%;
        transform: translate(-50%, 0);
        margin-top: 20px;
    }
`;

const shadowEl = css`
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: ${({ shadowWidth }: any) => shadowWidth || "24px"};
    background: linear-gradient(270deg, #fff 0%, #fff0 100%);
    background: linear-gradient(270deg, ${color("common.white", 1)} 0%, ${color("common.white", 0)} 100%);
    top: 0px;
    z-index: 2;
`;
export const xSwiperShadow = css`
    &.xng-swiper-with-shadow {
        &:has(.carousel-right-icon:not(.disabled)) {
            .swiper-horizontal::after {
                ${shadowEl}
                right: 0px;
            }
        }
        &:has(.carousel-left-icon:not(.disabled)) {
            .swiper-horizontal::before {
                ${shadowEl}
                left: 0px;
                background: linear-gradient(90deg, ${color("common.white", 1)} 0%, ${color("common.white", 0)} 100%);
            }
        }
    }
`;

export const xSwiperGreyShadow = css`
    &.xng-swiper-with-grey-shadow {
        &:has(.carousel-right-icon:not(.disabled)) {
            .swiper-horizontal::after {
                ${shadowEl}
                background: linear-gradient(90deg, ${color("common.ui8", 0)} 0%, ${color("common.ui8", 1)} 100%);
                right: 0px;
            }
        }
        &:has(.carousel-left-icon:not(.disabled)) {
            .swiper-horizontal::before {
                ${shadowEl}
                left: 0px;
                background: linear-gradient(270deg, ${color("common.ui8", 0)} 0%, ${color("common.ui8", 1)} 100%);
            }
        }
    }
`;
